import { OhayoQRConfig } from '@ohayojp/util';

export interface QROptions extends OhayoQRConfig {
  value: string;
}
